export default process.env.NODE_ENV === 'production' ?
'https://intense-dawn-54235.herokuapp.com' :
'http://localhost:1337';
